module.exports = __webpack_public_path__ + "img/barcelona_barrio_gotico.fe5789d9.jpg";